import { featuredMediaMentions as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'As Seen In',
  mentions: [
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '2BKUDj7TxoUzzqgWufC5mZ',
        type: 'Entry',
        createdAt: '2024-01-05T20:16:14.056Z',
        updatedAt: '2024-01-05T20:16:53.031Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        publishedVersion: 5,
        publishedAt: '2024-01-05T20:16:53.031Z',
        firstPublishedAt: '2024-01-05T20:16:53.031Z',
        createdBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        updatedBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        publishedCounter: 1,
        version: 6,
        publishedBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        automationTags: [],
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'mediaMentions',
          },
        },
      },
      fields: {
        title: 'Repairs or a Three-Day Ski Tour? For an Aspen Condo Buyer, It Was a No Brainer',
        description:
          'When the seller had trouble making fixes in time for the closing, the buyer and his agent came up with a creative solution\n',
        publicationLogo: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '79nn6YH1SdDiOsdPvv3wS3',
            type: 'Asset',
            createdAt: '2023-09-27T17:38:03.117Z',
            updatedAt: '2023-11-01T16:10:52.870Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            publishedVersion: 2,
            publishedAt: '2023-11-01T16:10:52.870Z',
            firstPublishedAt: '2023-11-01T16:10:52.870Z',
            createdBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '5DpyCihSpBkTZmjpTM9SEH',
              },
            },
            updatedBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '5DpyCihSpBkTZmjpTM9SEH',
              },
            },
            publishedCounter: 1,
            version: 3,
            publishedBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '5DpyCihSpBkTZmjpTM9SEH',
              },
            },
          },
          fields: {
            title: 'wall-street-journal.png',
            file: {
              url: '//images.ctfassets.net/3g4b24b0tvoz/79nn6YH1SdDiOsdPvv3wS3/0fe51983abc592a7f0dd24d9d949c66a/wall-street-journal.png',
              details: {
                size: 6540,
                image: {
                  width: 348,
                  height: 44,
                },
              },
              fileName: 'wall-street-journal.png',
              contentType: 'image/png',
            },
          },
        },
        publicationDate: '2024-01-04',
        url: 'https://www.wsj.com/real-estate/luxury-homes/aspen-condo-sale-ca3be52e',
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '3aeuXpcrs0bcm1mL69xzWo',
        type: 'Entry',
        createdAt: '2024-01-05T20:13:42.350Z',
        updatedAt: '2024-01-05T20:15:44.985Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        publishedVersion: 5,
        publishedAt: '2024-01-05T20:15:44.985Z',
        firstPublishedAt: '2024-01-05T20:15:44.985Z',
        createdBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        updatedBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        publishedCounter: 1,
        version: 6,
        publishedBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        automationTags: [],
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'mediaMentions',
          },
        },
      },
      fields: {
        title: 'Find Wintertime Bliss at These Five Alternatives to the North Pole',
        description:
          'From alpine Austria to Quebec City, follow wealthy home buyers in seeking out appealing opportunities in snowy towns that dazzle this time of year\n',
        publicationLogo: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '62kxAIMzodjKPYsZ94CVAU',
            type: 'Asset',
            createdAt: '2024-01-05T20:15:04.809Z',
            updatedAt: '2024-01-05T20:15:27.827Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            publishedVersion: 5,
            publishedAt: '2024-01-05T20:15:27.827Z',
            firstPublishedAt: '2024-01-05T20:15:27.827Z',
            createdBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '6LP7LfeSpLZ1gdZIjqjIgU',
              },
            },
            updatedBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '6LP7LfeSpLZ1gdZIjqjIgU',
              },
            },
            publishedCounter: 1,
            version: 6,
            publishedBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '6LP7LfeSpLZ1gdZIjqjIgU',
              },
            },
          },
          fields: {
            title: 'Mansion Global Logo',
            description: 'Mansion Global Logo',
            file: {
              url: '//images.ctfassets.net/3g4b24b0tvoz/62kxAIMzodjKPYsZ94CVAU/c197e69f2ccf1c4b52307ee3c4925a31/LO_MANSIONGLOBAL.format-webp.width-1060_ufOhhl6JvEFJfIbJ.webp',
              details: {
                size: 56436,
                image: {
                  width: 1060,
                  height: 219,
                },
              },
              fileName: 'LO_MANSIONGLOBAL.format-webp.width-1060_ufOhhl6JvEFJfIbJ.webp',
              contentType: 'image/webp',
            },
          },
        },
        publicationDate: '2023-12-24',
        url: 'https://www.mansionglobal.com/articles/find-wintertime-bliss-at-these-five-alternatives-to-the-north-pole-1621fb08',
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '2BKUDj7TxoUzzqgWufC5mJ',
        type: 'Entry',
        createdAt: '2024-01-05T20:16:14.056Z',
        updatedAt: '2024-01-05T20:16:53.031Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        publishedVersion: 5,
        publishedAt: '2024-01-05T20:16:53.031Z',
        firstPublishedAt: '2024-01-05T20:16:53.031Z',
        createdBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgW',
          },
        },
        updatedBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgW',
          },
        },
        publishedCounter: 1,
        version: 6,
        publishedBy: {
          sys: {
            type: 'Link',
            linkType: 'User',
            id: '6LP7LfeSpLZ1gdZIjqjIgU',
          },
        },
        automationTags: [],
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'mediaMentions',
          },
        },
      },
      fields: {
        title: 'Repairs or a Three-Day Ski Tour? For an Aspen Condo Buyer, It Was a No Brainer',
        description:
          'When the seller had trouble making fixes in time for the closing, the buyer and his agent came up with a creative solution\n',
        publicationLogo: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '79nn6YH1SdDiOsdPvv3wS3',
            type: 'Asset',
            createdAt: '2023-09-27T17:38:03.117Z',
            updatedAt: '2023-11-01T16:10:52.870Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            publishedVersion: 2,
            publishedAt: '2023-11-01T16:10:52.870Z',
            firstPublishedAt: '2023-11-01T16:10:52.870Z',
            createdBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '5DpyCihSpBkTZmjpTM9SEH',
              },
            },
            updatedBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '5DpyCihSpBkTZmjpTM9SEH',
              },
            },
            publishedCounter: 1,
            version: 3,
            publishedBy: {
              sys: {
                type: 'Link',
                linkType: 'User',
                id: '5DpyCihSpBkTZmjpTM9SEH',
              },
            },
          },
          fields: {
            title: 'wall-street-journal.png',
            file: {
              url: '//images.ctfassets.net/3g4b24b0tvoz/79nn6YH1SdDiOsdPvv3wS3/0fe51983abc592a7f0dd24d9d949c66a/wall-street-journal.png',
              details: {
                size: 6540,
                image: {
                  width: 348,
                  height: 44,
                },
              },
              fileName: 'wall-street-journal.png',
              contentType: 'image/png',
            },
          },
        },
        publicationDate: '2024-01-04',
        url: 'https://www.wsj.com/real-estate/luxury-homes/aspen-condo-sale-ca3be52e',
      },
    },
  ],
};

export default fakeProps(schema, TestData);
